module.exports = __webpack_public_path__ + "img/logo.10997d0f.jpg";